import { useMutation } from "react-query";
import { upsertObservedBehaviorsStrengths } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertObservedBehaviorsStrengths = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertObservedBehaviorsStrengths(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving the observed behaviors & strengths.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    upsertObservedBehaviorsStrengthsMutation: mutate,
    isUpsertObservedBehaviorsStrengthsLoading: isLoading,
    ...rest,
  };
};

export default useUpsertObservedBehaviorsStrengths;
